export const gridStylesV3 = {
  common: {
    backgroundColor: "#FFFFFF",
  },
  Lg: {
    gridCols: "3",
    gridRows:"0",
    padding: {},
    layout: "Grid"
  },
  Md: {
    gridCols: "2",
    gridRows:"0",
    padding: {},
    layout: "Grid"
  },
  Sm: {
    gridCols: "1",
    gridRows:"0",
    padding: {},
    height: "0",
    width: "100",
    heightMode: "px",
    widthMode: "%",
    layout: "Grid"
  },
};

export let styles = {
  common: {
    // border: "0",
    // borderRadius: "0",
    // fontSize: "16",
    // fontWeight: "400",
    // backgroundColor: "",
    // color: "",
    // borderColor: "",
  },
  Sm: {
    gridCols: "1",
    gridRows:"0",
    span: "1",
    rowSpan:"1",
    visible: true,
    width:'100',
    widthMode: "%",
  },
  Md: {
    gridCols: "1",
    gridRows:"0",
    span: "1",
    rowSpan:"1",
    visible: true,
  },
  Lg: {
    gridCols: "1",
    gridRows:"0",
    span: "1",
    rowSpan:"1",
    visible: true,
  },
};

export const containers = ['Grid', 'ExpansionPanel', 'Row', 'Column','TabBar',"Tab", 'CustomModal', "FlatList", 'Container']
export const conditionalElements = ['A8Modal', 'SnackBar', 'CustomModal']
export const wrapperLessElements = ['FAB']
export const canvasElements = [...conditionalElements, ...wrapperLessElements]
